const material = {
  // ==================== MATERIAL-SCHNELLERFASSUNG ====================
  'material.title': 'Material-Schnellerfassung',
  'material.subtitle': 'Materialstammdaten schnell erfassen und an SAP übermitteln',
  'material.inDevelopmentDesc': 'Die Material-Schnellerfassung bietet eine stark vereinfachte Maske mit reduzierten Pflichtfeldern, um neue Materialstämme schnell anzulegen.',

  // --- Tabs / Navigation ---
  'material.tabCapture': 'Erfassen',
  'material.tabList': 'Übersicht',
  'material.tabConfig': 'Feldkonfiguration',
  'material.newMaterial': 'Neues Material',

  // --- Org-Leiste / Kopf ---
  'material.matnr': 'Materialnummer',
  'material.matnrAuto': 'leer = interne Vergabe',
  'material.werks': 'Werk',
  'material.vkorg': 'VerkOrg',
  'material.vtweg': 'Vertriebsweg',
  'material.fromTemplate': 'Aus Vorlage',

  // --- Felder allgemein ---
  'material.selectPlaceholder': '– bitte wählen –',
  'material.yes': 'Ja',
  'material.descEn': 'Bezeichnung (EN)',
  'material.addEn': 'Englische Bezeichnung hinzufügen',
  'material.hideEn': 'Englische Bezeichnung ausblenden',
  'material.noFieldsConfigured': 'Es sind keine Felder aktiviert. Bitte in der Feldkonfiguration Felder aktivieren.',

  // --- Aktionen Erfassen ---
  'material.saveDraft': 'Als Entwurf speichern',
  'material.create': 'Anlegen',
  'material.update': 'Aktualisieren',
  'material.savedReady': 'Material angelegt.',
  'material.savedDraft': 'Entwurf gespeichert.',
  'material.missingRequired': 'Bitte alle Pflichtfelder (*) ausfüllen.',
  'material.saveError': 'Speichern fehlgeschlagen.',
  'material.fillProgress': '{filled} / {total} Felder ausgefüllt',
  'material.collapseAll': 'Alle einklappen',
  'material.expandAll': 'Alle ausklappen',
  'material.texts': 'Texte',
  'material.addText': 'Text hinzufügen',
  'material.textPlaceholder': 'Text eingeben…',
  'material.fillCol': 'Füllstand',

  // --- Dublettenprüfung ---
  'material.dupSetting': 'Dublettenprüfung beim Anlegen',
  'material.dupSettingHint': 'Optional: prüft vor dem Anlegen, ob ein ähnliches Material existiert (gegen Doppelanlage).',
  'material.dupTitle': 'Mögliche Dublette gefunden',
  'material.dupSubtitle': 'Es existieren ähnliche Materialien. Bitte prüfen, ob es sich um eine Doppelanlage handelt.',
  'material.dupSourceMaterial': 'Erfassung',
  'material.dupSourceCatalog': 'Katalog',
  'material.dupSourceSap': 'SAP-Materialstamm',
  'material.dupReason_ean': 'gleiche EAN',
  'material.dupReason_bismt': 'gleiche Materialnummer',
  'material.dupReason_desc': 'ähnliche Bezeichnung',
  'material.dupReason_matkl': 'gleiche Warengruppe',
  'material.dupMatch': 'Übereinstimmung',
  'material.dupCancel': 'Abbrechen',
  'material.dupProceed': 'Trotzdem anlegen',
  'material.dupProceedUpdate': 'Trotzdem speichern',
  'material.textLang': 'Sprache des Textes',

  // --- Feldkonfig-Presets ---
  'material.presets': 'Presets',
  'material.presetChoose': '– Preset wählen –',
  'material.presetLoad': 'Laden',
  'material.presetSaveAs': 'Als Preset speichern',
  'material.presetReset': 'Auf Standard zurücksetzen',
  'material.presetNamePrompt': 'Name für die Konfiguration:',
  'material.presetSaved': 'Preset gespeichert.',
  'material.presetSaveError': 'Preset konnte nicht gespeichert werden.',
  'material.presetApplied': 'Preset „{name}" angewendet (noch nicht gespeichert).',
  'material.presetConfirmDelete': 'Preset „{name}" wirklich löschen?',
  'material.presetDeleted': 'Preset gelöscht.',
  'material.presetDeleteError': 'Preset konnte nicht gelöscht werden.',
  'material.settingsSaved': 'Einstellung gespeichert.',

  // --- PDF-Anhänge ---
  'material.attachments': 'Anhänge (PDF)',
  'material.attAdd': 'PDF hinzufügen',
  'material.attDropHint': 'PDFs hierher ziehen oder „PDF hinzufügen"',
  'material.attDropHintNew': 'PDFs hierher ziehen — werden nach dem Speichern hochgeladen',
  'material.attDropNow': 'Loslassen zum Hochladen',
  'material.attPending': 'wird beim Speichern hochgeladen',
  'material.attSaveFirst': 'Material zuerst speichern, dann können PDFs angehängt werden.',
  'material.attEmpty': 'Noch keine Anhänge.',
  'material.attOnlyPdf': 'Nur PDF-Dateien erlaubt.',
  'material.attUploaded': 'PDF angehängt.',
  'material.attUploadError': 'Upload fehlgeschlagen.',
  'material.attLoadError': 'Anhänge konnten nicht geladen werden.',
  'material.attDownload': 'Öffnen',
  'material.attConfirmDelete': 'Diesen Anhang wirklich löschen?',
  'material.attDeleted': 'Anhang gelöscht.',
  'material.attDeleteError': 'Löschen fehlgeschlagen.',

  // --- Feldkonfiguration (Admin) ---
  'material.configTitle': 'Felder verwalten',
  'material.activeFields': '{n} von {total} Feldern aktiv',
  'material.configSave': 'Konfiguration speichern',
  'material.configSaved': 'Feldkonfiguration gespeichert.',
  'material.configSaveError': 'Konfiguration konnte nicht gespeichert werden.',
  'material.configLoadError': 'Feldkonfiguration konnte nicht geladen werden.',
  'material.coreField': 'Pflichtkern',
  'material.toggleActive': 'Aktiv',
  'material.toggleRequired': 'Pflicht',
  'material.configSearch': 'Feld suchen (Bezeichnung, SAP-Feld)…',
  'material.allActive': 'Alle aktiv',
  'material.allRequired': 'Alle Pflicht',
  'material.allSap': 'Alle SAP',
  'material.allOff': 'Alle ab',
  'material.toggleSap': 'Aus SAP',
  // --- Material aus SAP laden ---
  'material.sapLoad': 'Aus SAP laden',
  'material.sapLoadTitle': 'Material aus SAP laden',
  'material.sapLoadSubtitle': 'SAP-Materialstamm durchsuchen und als Vorlage übernehmen.',
  'material.sapSearchPlaceholder': 'Suche im SAP-Materialstamm (Bezeichnung, Nummer, EAN)…',
  'material.sapNoResults': 'Keine SAP-Materialien gefunden.',
  'material.sapNoVisibleFields': 'Keine Felder als „aus SAP sichtbar" konfiguriert.',
  'material.sapUseAsTemplate': 'Als Vorlage',
  'material.sapSearchError': 'SAP-Suche fehlgeschlagen.',
  'material.sapLoadError': 'SAP-Material konnte nicht geladen werden.',

  // --- Übersicht ---
  'material.searchPlaceholder': 'Suche (Bezeichnung, Nummer, Warengruppe)…',
  'material.allStatus': 'Alle Status',
  'material.status_draft': 'Entwurf',
  'material.status_ready': 'Bereit',
  'material.status_transferred': 'Übertragen',
  'material.description': 'Bezeichnung',
  'material.mtart': 'Materialart',
  'material.matkl': 'Warengruppe',
  'material.statusCol': 'Status',
  'material.actions': 'Aktionen',
  'material.edit': 'Bearbeiten',
  'material.useAsTemplate': 'Als Vorlage nutzen',
  'material.transfer': 'An SAP übertragen',
  'material.mirror': 'In Katalog spiegeln',
  // --- SAP-Transfer ---
  'material.trfTitle': 'An SAP übertragen',
  'material.trfStubNote': 'Diese Umgebung sendet nicht an SAP (MATERIAL_SAP_TARGET=mock): das BAPI-Payload wird erzeugt und protokolliert, der Status wird auf „Übertragen" gesetzt, eine SAP-Materialnummer gibt es nicht.',
  'material.trfConfirm': 'An SAP übertragen',
  'material.trfUnmapped': 'Noch nicht gemappt (Abstimmung nötig)',
  'material.trfDone': 'An SAP übertragen.',
  'material.trfError': 'Übertragung fehlgeschlagen.',
  'material.trfPreviewError': 'Vorschau konnte nicht geladen werden.',
  'material.trfTargetSap': 'Diese Umgebung schreibt in SAP (BAPI_MATERIAL_SAVEDATA über den Adapter). „In SAP prüfen" ruft die BAPI auf und rollt zurück – es wird nichts angelegt; „An SAP übertragen" legt das Material an.',
  'material.trfTargetNone': 'Die Übertragung an SAP ist in dieser Umgebung abgeschaltet (MATERIAL_SAP_TARGET=none).',
  'material.trfCheck': 'In SAP prüfen',
  'material.trfCheckOk': 'SAP-Prüfung ok – nichts geschrieben.',
  'material.trfCheckFail': 'SAP lehnt das Material ab – siehe Meldungen.',
  'material.trfMessages': 'SAP-Meldungen',
  'material.trfMatnr': 'Materialnummer',
  'material.trfNumberInternal': 'intern vergeben',
  'material.trfNumberExternal': 'extern vorgegeben',
  'material.trfViews': 'Sichten',
  'material.delete': 'Löschen',
  'material.emptyList': 'Noch keine Materialien angelegt.',
  'material.listError': 'Materialliste konnte nicht geladen werden.',
  'material.loadError': 'Material konnte nicht geladen werden.',
  'material.mirrorSuccess': 'Material in den Katalog gespiegelt.',
  'material.mirrorError': 'Spiegeln fehlgeschlagen.',
  'material.confirmDelete': 'Dieses Material wirklich löschen?',
  'material.deleteSuccess': 'Material gelöscht.',
  'material.deleteError': 'Löschen fehlgeschlagen.',
  // Change-Pfad (übertragene Materialien in SAP aktualisieren)
  'material.updTitle': 'In SAP aktualisieren',
  'material.updConfirm': 'In SAP aktualisieren',
  'material.updCheck': 'Änderungen in SAP prüfen',
  'material.updChanges': 'Änderungen gegenüber dem letzten SAP-Stand',
  'material.updNoChanges': 'Keine Änderungen gegenüber dem letzten SAP-Stand – nichts zu senden.',
  'material.updDone': 'Material in SAP aktualisiert.',
  'material.updCheckOk': 'SAP-Prüfung ok – Änderung nicht geschrieben.',
  'material.updCheckFail': 'SAP lehnt die Änderung ab – siehe Meldungen.',
  'material.updTargetSap': 'Diese Umgebung schreibt in SAP. „Änderungen in SAP prüfen" ruft die BAPI auf und rollt zurück (keine Nummer wird verbraucht); „In SAP aktualisieren" ändert das vorhandene Material – nur die geänderten Felder.',
  'material.updNoBaseline': 'Kein Vergleichsstand: für dieses Material ist keine erfolgreiche Übertragung protokolliert.',
  'material.trfChangeFrom': 'vorher',
  'material.trfChangeTo': 'neu',
  'material.trfEmpty': '(leer)',
  // Alternative Mengeneinheiten
  'material.units': 'Alternative Mengeneinheiten',
  'material.addUnit': 'Einheit hinzufügen',
  'material.unitAlt': 'Einheit',
  'material.unitNum': 'Zähler',
  'material.unitDen': 'Nenner',
  'material.unitEan': 'EAN (optional)',
  'material.unitHint': 'Umrechnung in die Basiseinheit: 1 {alt} = {num}/{den} {base}',
  // „Aus SAP laden": Quelle
  'material.sapSourceLive': 'Quelle: SAP live über den Adapter',
  'material.sapSourceMirror': 'Quelle: lokaler Spiegel (kein Live-Zugriff in dieser Umgebung)',
  'material.sapSearchHint': 'Suchbegriff eingeben – Bezeichnung (mehrere Wörter möglich) oder Materialnummer.',
  'material.sapDeleted': 'Löschvormerkung',
};

export default material;
